import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import missionReducer from './slices/missionSlice';
import { persistStore, persistReducer } from 'redux-persist';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { combineReducers } from 'redux';

// Configuración de persistencia simplificada - solo a nivel root
const rootPersistConfig = {
  key: 'root',
  storage: AsyncStorage,
  whitelist: ['auth'], // Solo persistir auth
  throttle: 500 // Reducir throttle para mejor responsividad
};

// Combinar reducers sin persistencia duplicada
const rootReducer = combineReducers({
  auth: authReducer,
  missions: missionReducer
});

// Crear reducer persistente solo a nivel root
const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

// Crear store optimizado
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionsPaths: ['register', 'rehydrate']
      },
      // Optimizaciones para móviles
      immutableCheck: { warnAfter: 128 }
    })
});

// Crear persistor
export const persistor = persistStore(store);

export default store;